/*
 * First-Party A/B Exposure-Beacon
 * Zählt eindeutige Besucher je Test-Variante im eigenen Backend — unabhängig von GA4/Cookie-Consent.
 * Anonyme ID in localStorage (keine PII). Sendet je Session nur neu hinzugekommene Tests.
 *
 * window.wmTrackExposure() kann von aussen (z.B. ATC-Handler) aufgerufen werden, damit Tests,
 * die erst beim Add-to-Cart in __wmTests kommen (cart_type), SOFORT erfasst werden — ohne auf
 * einen neuen Pageview zu warten (sonst würde die drawer-Variante untererfasst).
 */
(function () {
  'use strict';

  // Automation/Headless raus (Selenium/Puppeteer setzen navigator.webdriver)
  try { if (navigator.webdriver) return; } catch (e) {}

  var API = 'https://wunschmoment-backend.vercel.app/api/experiment/exposure';
  var EVENT_API = 'https://wunschmoment-backend.vercel.app/api/experiment/event';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function anonId() {
    var anon = lsGet('wm_anon_id');
    if (!anon) {
      try {
        anon = (crypto && crypto.randomUUID) ? crypto.randomUUID().replace(/-/g, '') : null;
      } catch (e) { anon = null; }
      if (!anon) anon = Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
      lsSet('wm_anon_id', anon);
    }
    return anon;
  }

  function sendExposure() {
    var tests = window.__wmTests;
    if (!tests || typeof tests !== 'object') return;

    // Nur Tests senden, die diese Session noch nicht (mit diesem Wert) gemeldet wurden
    var sent = {};
    try { sent = JSON.parse(ssGet('wm_exposure_sent') || '{}'); } catch (e) {}
    var pending = {};
    var has = false;
    for (var k in tests) {
      if (Object.prototype.hasOwnProperty.call(tests, k) && tests[k] && sent[k] !== tests[k]) {
        pending[k] = tests[k];
        has = true;
      }
    }
    if (!has) return;

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ anonId: anonId(), tests: pending }),
      keepalive: true,
      credentials: 'omit'
    }).then(function () {
      for (var key in pending) sent[key] = pending[key];
      ssSet('wm_exposure_sent', JSON.stringify(sent));
    }).catch(function () {});
  }

  // Anon-ID global bereitstellen (z.B. für ATC → Cart-Attribut → Checkout-Pixel)
  window.wmAnonId = anonId();

  // Von aussen aufrufbar (ATC-Handler): sofort nachmelden
  window.wmTrackExposure = sendExposure;

  /* Funnel-Event ans eigene Backend. Wird von den bestehenden Publish-Helpern zusätzlich zu GA4
     aufgerufen. Pro Event pro Session nur einmal (Server dedupliziert zusätzlich pro Tag). Trägt
     die aktuellen __wmTests → Attribution je Variante (cart_type kommt erst ab ATC dazu). */
  // Events, die nur EINMAL PRO NUTZER gezählt werden sollen (nicht pro Fire).
  var ONCE_PER_USER = { experiment_view: 1 };

  window.wmTrackEvent = function (event) {
    if (!event) return;
    var tests = window.__wmTests;
    if (!tests || typeof tests !== 'object') return;

    // Einmal-pro-Nutzer-Events: über localStorage (an die anon_id gebunden) sperren.
    if (ONCE_PER_USER[event]) {
      if (lsGet('wm_ev_once_' + event)) return;
      lsSet('wm_ev_once_' + event, '1');
    }

    // Sonst KEIN Dedup: jeder Fire zählt → Server-Hits = Gesamt-Events,
    // Zeilen = eindeutige Nutzer (pro Tag). So sind beide Sichten möglich.
    var payloadTests = {};
    var has = false;
    for (var k in tests) {
      if (Object.prototype.hasOwnProperty.call(tests, k) && tests[k]) {
        payloadTests[k] = tests[k];
        has = true;
      }
    }
    if (!has) return;

    fetch(EVENT_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ anonId: anonId(), event: event, tests: payloadTests }),
      keepalive: true,
      credentials: 'omit'
    }).catch(function () {});
  };

  // Beim Seitenaufruf einmal
  sendExposure();
})();
